<template>
  <DatatableReportV3
    id="appointments-table"
    ref="datatable"
    :config="config"
    :source="source"
    :filters="filters"
    :map-records="ajaxConfig"
    subpage
    no-download
    hide-global-filters
    hide-filters
    hide-page-length-select
    hide-header
    :default-page-length="5"
    @draw-complete="$emit('draw-complete', $event)"
  />
</template>

<script>
import { EventBus } from "@/lib/event_bus.js";

import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    filters: {
      type: Array,
      default: () => []
    },
    source: {
      type: String,
      default: ""
    },
    jobId: {
      type: Number,
      default: null
    }
  },
  emits: ["draw-complete"],
  data() {
    return {
      config: {
        order: [[1, "desc"]],
        columns: [
          { data: "when", title: "Date & Time", searchable: false },
          { data: "appointment", searchable: false },
          { data: "status", searchable: false },
          { data: "technician", searchable: false },
          { data: "task_type", title: "Service Category", searchable: false }
        ]
      }
    };
  },
  methods: {
    ajaxConfig(config) {
      config.job_id = this.jobId;

      return config;
    },
    refreshTable() {
      EventBus.$emit("refresh-datatable");
    }
  }
};
</script>

<style lang="scss">
.pinned-icon {
  color: white;
  margin-right: 0.2rem;
  text-shadow: 0 0 6px rgba(34, 34, 34, 0.8);
}
#appointments-table_wrapper div.dt-scroll {
  height: auto !important;
  min-height: auto !important;
}
</style>
